import { useAuth } from "@/context/AuthContext";

/**
 * Permission helpers. Use anywhere we need to gate UI by section level.
 * Admin bypasses all checks.
 */
export const usePermissions = () => {
  const { user } = useAuth();

  const can = (section, level = "read") => {
    if (!user || user === false) return false;
    if (user.role === "admin") return true;
    const perms = user.permissions || {};
    const granted = perms[section] || "none";
    if (granted === "none") return false;
    if (level === "read") return granted === "read" || granted === "rw";
    if (level === "rw") return granted === "rw";
    return false;
  };

  return {
    can,
    canRead: (section) => can(section, "read"),
    canWrite: (section) => can(section, "rw"),
    isAdmin: user?.role === "admin",
    user,
  };
};
